module.exports = __webpack_public_path__ + "img/935555_F6DAD9_D39393_593333-256px.11fff864.png";